import { render, staticRenderFns } from "./UserBioPanel.vue?vue&type=template&id=7c2380d5"
import script from "./UserBioPanel.vue?vue&type=script&lang=js"
export * from "./UserBioPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports